import React, { createContext, useMemo, useState } from "react";

const FileUploadDataContext = createContext({});

export function FileUploadDataProvider({ children }) {
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [awaitingResponse, setAwaitingResponse] = useState(false);
  const [uploadResponse, setUploadResponse] = useState({});
  const [isAsyncProcessing, setIsAsyncProcessing] = useState(false);
  /***
   * USAGE: The variable "fileIdFromSuccessFileUploadResponse" represents the id assigned to a file that has been uploaded recently.
   * This will be utilized to generate a profile report.
   */
  const [
    fileIdFromSuccessFileUploadResponse,
    setFileIdFromSuccessFileUploadResponse,
  ] = useState(null);

  const props = useMemo(
    () => ({
      page,
      setPage,
      open,
      setOpen,
      uploadResponse,
      setUploadResponse,
      awaitingResponse,
      setAwaitingResponse,
      isAsyncProcessing,
      setIsAsyncProcessing,
      fileIdFromSuccessFileUploadResponse,
      setFileIdFromSuccessFileUploadResponse,
    }),
    [
      open,
      page,
      uploadResponse,
      awaitingResponse,
      isAsyncProcessing,
      fileIdFromSuccessFileUploadResponse,
    ]
  );

  return (
    <FileUploadDataContext.Provider value={props}>
      {children}
    </FileUploadDataContext.Provider>
  );
}

export default FileUploadDataContext;
